import { scan, to_array } from "@pdfking/rfunc"
export default (
  events: string | string[],
  pattern: null | string | string[],
  func: (target: Element, event: Event) => void
): void => {
  if (!func) throw "not a funct"

  const patternStr = to_array(pattern).join(",")

  scan((event: string) => {
    if (patternStr) {
      document.addEventListener(
        event,
        e => {
          for (
            let target: EventTarget | null = e.target;
            target && target != document;
            target = (target as Element).parentNode
          ) {
            if ((target as Element).matches?.(patternStr)) {
              func(target as Element, e)
              break
            }
          }
        },
        false
      )
    } else {
      document.addEventListener(event, e => func(e.target as Element, e), false)
    }
  }, events)
}
